module.exports = __webpack_public_path__ + "img/product_bg.0cfa6871.jpg";